<template>
	<div class="container">
		<div class="contentleft" :style="{ maxHeight: isExpanded ? 'none' : '30px', overflow: 'hidden' }">
			<el-checkbox-group v-model="selectedOptions" @change="change">
				<el-checkbox size="default" v-for="option in options" :key="option.Code" :label="option.Code">
					{{ option.Name }}
				</el-checkbox>
			</el-checkbox-group>
		</div>

		<div class="toggle-btn" :class="{ expanded: isExpanded }" @click="toggleExpanded">
			{{ isExpanded ? '收起' : '展开' }}
			<i v-if="isExpanded"><el-icon>
					<ArrowUp />
				</el-icon></i>
			<i v-else="!isExpanded"><el-icon>
					<ArrowDown />
				</el-icon></i>
		</div>
	</div>
	<div class="selecteddiv" v-if="!IsNewVersion && selectedOptions.length>0 && selectedOptions[0]!='0'">
		已选择：
		<el-button size="small" class="selected-tag" v-for="code in selectedOptions" :key="code"
			@click="clearItem(code)">{{ getOptionName(code) }}<el-icon>
				<Close />
			</el-icon></el-button>
		<el-button size="small" class="clearAllBtn" @click="clearAll"><el-icon>
				<Delete />
			</el-icon> &nbsp;清空</el-button>
	</div>
</template>

<script>
	export default {
		props: {
			schTeSe: {
				type: Array,
				default: () => [] // 使用工厂函数返回默认值
			},
			IsNewVersion:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
				isExpanded: false,
				selectedOptions: ['0'],
				options: [],
			}
		},
		methods: {
			//点击展开-收起
			toggleExpanded() {
				this.isExpanded = !this.isExpanded;
			},
			//回显已经选择了哪些特色
			getOptionName(code) {
				const option = this.options.find(opt => opt.Code === code);
				return option ? option.Name : '';
			},
			//删除指定的院校特色
			clearItem(code) {
				this.selectedOptions = this.selectedOptions.filter(item => item != code);
				this.change();
			},
			//清空所有已选择的特色
			clearAll(code) {
				this.selectedOptions = [];
				this.change();
			},
			//父组件中 点击 清空所有条件按钮 时调用此方法
			removeAll(){
				this.selectedOptions = [];
				this.selectedOptions.push("0");
			},
			//复选框选择变化时触发
			change() {
				if (this.selectedOptions.length == 0) {
					this.selectedOptions.push("0");
					this.$emit("schTeSeChange", '');
					return;
				}
				let noLimitIdx = this.selectedOptions.indexOf("0");
				if (noLimitIdx == 0 && this.selectedOptions.length > 1) {
					this.selectedOptions.splice(0, 1);
				} else if (noLimitIdx > 0) {
					this.selectedOptions = [];
					this.selectedOptions.push("0");
				}
				let val = this.selectedOptions.length == 1 && this.selectedOptions[0] == "0" ? '' : this.selectedOptions
					.join(',');
				this.$emit("schTeSeChange", val);
			}
		},
		watch: {
			// 监听 prop 的变化
			schTeSe: {
				immediate: true, // 立即执行一次
				handler(newVal) {
					this.options = newVal;
				}
			}
		},
		mounted() {

		},
		created() {
			console.log('接收参数院校特色', this.schTeSe);
			this.options = this.schTeSe;
		}


	}
</script>

<style scoped>
	.container {
		display: flex;
		justify-content: flex-start;
	}

	.toggle-btn {
		width: 220px !important;
		display: flex;
		justify-content: flex-start;
		margin-top: 5px;
		cursor: pointer;
	}

	.selected-tag {
		margin-right: 10px;
		margin-top: 5px;
		margin-bottom: 5px;
	}

	.selecteddiv {
		margin-top: 10px;
	}

	.clearAllBtn {
		color: red;
	}
</style>